import Commission from "../../../../assets/ib/Commission";
import Wallet from "../../../../assets/Wallet";
import LiveAccount from "../../../../assets/ib/LiveAccount";
import MyIbTree from "../../../../assets/ib/MyIbTree";
import MyTeam from "../../../../assets/ib/MyTeam";
import Promotion from "../../../../assets/ib/Promotion";
import Report from "../../../../assets/ib/Report";
import Dashboard from "../../../../assets/user/Dashboard";
import Support from "../../../../assets/user/Support";
import Kyc from "../../../../assets/ib/Kyc";
import IbApproved from "../../../../assets/ib/IbApproved";
import IbInbox from "../../../../assets/ib/inbox";
import Disc from "../../../../assets/user/Disc";
import Reports from "../../../../assets/user/Reports";

export const IBSidebarData = [
    {
        title: 'Dashboard',
        icon: <Dashboard />,
        url: '/ib/dashboard',
        activeUrl: ['/ib/dashboard']
    },
    // {
    //     title: 'Inbox',
    //     icon: <IbInbox />,
    //     url: '/ib/inbox',
    //     activeUrl: ['/ib/inbox']
    // },
    {
        title: 'KYC',
        icon: <Kyc />,
        url: '/ib/kyc_manager',
        activeUrl: ['/ib/kyc_manager']
    },
    {
        title: 'IB Wallet',
        icon: <Wallet />,
        url: '/ib/withdraw',
        activeUrl: ['/ib/withdraw']
    },
    {
        title: 'IB Manager',
        icon: <IbApproved />,
        url: '/ib/ib_manager',
        activeUrl: ['/ib/ib_manager', '/ib/ib_details', '/ib/ib_details/approved']
    },
    {
        title: 'My Team',
        icon: <MyTeam />,
        url: '/ib/my_trader_team',
        activeUrl: ['/ib/my_trader_team'],
    },
    {
        title: 'IB Tree',
        icon: <MyIbTree />,
        url: '/ib/tree',
        activeUrl: ['/ib/tree']
    },
    {
        title: 'Commission',
        icon: <Commission />,
        url: '/ib/commission',
        activeUrl: ['/ib/commission']
    },
    {
        title: 'Distribution',
        icon: <Commission />,
        url: '/ib/commission_distribute',
        activeUrl: ['/ib/commission_distribute']
    },
    {
        title: 'Live Account',
        icon: <LiveAccount />,
        url: '/ib/live_account',
        activeUrl: ['/ib/live_account']
    },
    {
        title: 'Reports',
        icon: <Reports />,
        activeUrl: [],
        kycApproval: true,
        child: [

            {
                title: 'Earning',
                icon: <Disc />,
                url: '/ib/commission',
                activeUrl: ['/ib/commission'],
            },
            {
                title: 'Withdraw',
                icon: <Disc />,
                url: '/ib/withdraw',
                activeUrl: ['/ib/withdraw'],
            },
            {
                title: 'My Team',
                icon: <Disc />,
                url: '/ib/my_trader_team',
                activeUrl: ['/ib/my_trader_team'],
            },
            {
                title: 'My SubIB',
                icon: <Disc />,
                url: '/ib/ib_manager',
                activeUrl: ['/ib/ib_manager'],
            },

        ],
    },
    // {
    //     title: 'Reports',
    //     icon: <Report />,
    //     url: '/ib/reports',
    //     activeUrl: ['/ib/reports']
    // },
    // {
    //     title: 'Promotion Kit',
    //     icon: <Promotion />,
    //     url: '/ib/promotion',
    //     activeUrl: ['/ib/promotion']
    // },
    // {
    //     title: 'Support',
    //     icon: <Support />,
    //     url: '/ib/support',
    //     activeUrl: ['/ib/support', '/ib/view_ticket']
    // },

]